import { zodResolver } from '@hookform/resolvers/zod';
import {
  FieldValues,
  FormProvider,
  SubmitHandler,
  UseFormProps,
  UseFormReturn,
  useForm,
} from 'react-hook-form';
import { ZodType } from 'zod';

interface FormProps<T extends FieldValues> {
  form: UseFormReturn<T>;
  onSubmit: SubmitHandler<T>;
  children: React.ReactNode;
  className?: string;
}

export function Form<T extends FieldValues>({
  form,
  onSubmit,
  children,
  className,
}: FormProps<T>): JSX.Element {
  return (
    <FormProvider {...form}>
      {/* eslint-disable-next-line @typescript-eslint/no-misused-promises */}
      <form
        onSubmit={(e) => {
          e.preventDefault();
          // eslint-disable-next-line no-console
          form.handleSubmit(onSubmit)(e).catch(console.error);
        }}
        className={className}
      >
        {children}
      </form>
    </FormProvider>
  );
}

// Helper hook to create form with Zod validation
export function useZodForm<T extends FieldValues>({
  schema,
  ...formConfig
}: {
  schema: ZodType<T>;
} & Omit<UseFormProps<T>, 'resolver'>): UseFormReturn<T> {
  return useForm<T>({
    ...formConfig,
    resolver: zodResolver(schema),
  });
}
